import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import ProductGridItem from '../components/ProductGridItem';
import ProductRowScroller from '../components/ProductRowScroller';

export default class DynamicFeaturedCollection {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);

    // Product items
    this.productItems = [];
    const $productItems = this.$el.find('[data-product-item]');

    $productItems.each((i, productItem) => {
      this.productItems.push(
        new ProductGridItem({
          el: productItem,
          id: this.section.id,
        }),
      );
    });

    this.ProductRowScroller = new ProductRowScroller(section.el.querySelector('[data-product-row]'));

    this._updatePrices();
  }

  _updatePrices() {
    this.$el.find('.money').each((index, el) => CurrencyConverter.update(el));
  }

  onSectionUnload() {
    this.productItems.forEach((productItem) => {
      productItem.unload();
    });

    this.ProductRowScroller.unload();
  }
}
